export function reminderTagClassName(day, completed) {
  if (completed) return 'completed-tag';

  return `past-due past-due-in-${day}-days`
}
